import { render } from "./PillComponent.vue?vue&type=template&id=3aa46487"
import script from "./PillComponent.vue?vue&type=script&lang=js"
export * from "./PillComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__